<template>
  <div>
    <v-row class="mb-4">
      <Breadcrump :crumbs="crumbs" />
      <v-spacer />
    </v-row>

    <v-card>
      <v-tabs v-model="tab" background-color="primary" dark>
        <v-tab v-if="hasGradePerm">درجه کیفی مجموعه</v-tab>
        <v-tab v-if="hasTypePerm">نوع مجموعه</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <!-- Location Grades -->
        <v-tab-item v-if="hasGradePerm">
          <CrudTable
            title="لیست درجات مجموعه"
            api="/locationGrade"
            permissionPrefix="LocationGrade"
          />
        </v-tab-item>

        <!-- Location Types -->
        <v-tab-item v-if="hasTypePerm">
          <CrudTable
            title="لیست انواع مجموعه"
            api="/locationType"
            permissionPrefix="LocationType"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>
<script>
import Breadcrump from "@/components/common/Breadcrump.vue";
import CrudTable from "@/components/complex/CrudTable.vue";
import { hasPermission } from "@/composables/permissions";

export default {
  name: "ComplexSettings",
  components: {
    Breadcrump,
    CrudTable
  },
  data() {
    return {
      tab: 0,
      crumbs: [
        { text: "خانه", disabled: false, href: "/" },
        { text: "تنظیمات مجموعه", disabled: true }
      ]
    };
  },
  computed: {
    hasGradePerm() {
      return hasPermission("LocationGrade_View");
    },
    hasTypePerm() {
      return hasPermission("LocationType_View");
    }
  }
};
</script>
